module.exports = __webpack_public_path__ + "img/upgradeOK.d4f965e0.svg";